/**
 * A product's active (enabled) prices — the multi-price source of truth for what
 * a buyer can choose, replacing the deprecated legacy scalar fields
 * (`product.price` / `type` / `interval`) which drift from `prices[]`.
 *
 * "Active" = enabled. (Disabled prices are excluded; hidden-but-enabled prices
 * still count — they're revealable via a query param.)
 */
export default function getActivePrices(product) {
  return (product?.prices ?? []).filter(price => price?.enabled !== false);
}

/**
 * The first active price by `order` — the price that stands in for the legacy
 * product-level scalars (mirrors getProductType's resolver and the API's
 * deriveLegacyProductType). null when there are no enabled prices.
 */
export function firstActivePrice(product) {
  return (
    [...getActivePrices(product)].sort((a, b) => (a.order ?? 0) - (b.order ?? 0))[0] ?? null
  );
}
